import firebase from 'firebase/app';
import "firebase/auth";
import "firebase/firestore";

firebase.initializeApp({
    apiKey: "AIzaSyAHiyTFEX0Lco5gz4aAYu-5w9nbvil6dqM",
    authDomain: "crwn-clth.firebaseapp.com",
    databaseURL: "https://crwn-clth.firebaseio.com",
    projectId: "crwn-clth",
    storageBucket: "crwn-clth.appspot.com",
    messagingSenderId: "794367195282",
    appId: "1:794367195282:web:a68f416e63be03f8924e4b",
    measurementId: "G-41FCMYPVBG",
});

export default firebase;
